import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './global.css'; // ← Design tokens + base reset
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

import Navbar from './components/Navbar/Navbar';
import Homepage from './pages/Homepage/Homepage';
import AboutPage from './pages/AboutPage/AboutPage';
import MenuPage from './pages/MenuPage/MenuPage';
import BrewsSection from './pages/BrewsSection/BrewsSection';
import ContactPage from './pages/ContactPage/ContactPage';
import Footer from './components/Footer/Footer';
import GalleryPage from './pages/GalleryPage/GalleryPage';
import Reservations from './pages/Reservations/Reservations';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import BrewsPage from './pages/BrewsPage/BrewsPage';


const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Navbar />

      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/reservation" element={<Reservations />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/brews" element={<BrewsPage />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default App;


// node generate-gallery-manifest.js